import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  Grid,
  makeStyles,
  MenuItem,
  Radio,
  RadioGroup,
  TextField
} from '@material-ui/core'
import { GENDERS } from 'constants/client'
import {
  approximateBuyOptions,
  budgetOptions,
  carOwnershipOptions,
  visitTypeOptions
} from 'constants/optionsRSE'

const useStyles = makeStyles(() => ({
  radioBox: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10
  },
  textFields: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    marginBottom: 20
  },
  creditPercent: {
    width: '100%'
  },
  textArea: {
    marginBottom: 20
  }
}))

export const WorkListClientNeeds = ({
  commentsRSE,
  onChangeRse = () => null,
  isDisabled = false
}) => {
  const classes = useStyles()

  const onChange = e => {
    const { name, value } = e.target
    if (name === 'prepayment') {
      return onChangeRse({
        [name]: value?.toString()?.toNum() || 0
      })
    }
    onChangeRse({ [name]: value })
  }
  const onCheck = e => {
    const { name, checked } = e.target
    onChangeRse({ [name]: checked })
  }

  return (
    <>
      <div className={classes.radioBox}>
        <RadioGroup
          aria-label="gender"
          name="gender"
          value={commentsRSE?.gender}
          onChange={onChange}
          row
          className={classes.radioBox}
        >
          <FormControlLabel
            value={GENDERS[0].code}
            control={<Radio color={'primary'} disabled={isDisabled} />}
            label={GENDERS[0].title}
          />
          <FormControlLabel
            value={GENDERS[1].code}
            control={<Radio color={'primary'} disabled={isDisabled} />}
            label={GENDERS[1].title}
          />
        </RadioGroup>
      </div>
      <Grid container spacing={4}>
        <Grid item xs={12} md={4}>
          <TextField
            label={'Тип визита'}
            fullWidth
            select
            name={'visitType'}
            value={commentsRSE?.visitType}
            onChange={onChange}
            disabled={isDisabled}
          >
            {visitTypeOptions.map(option => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField
            label={'Бюджет покупки,₸'}
            name={'budget'}
            value={commentsRSE?.budget}
            onChange={onChange}
            fullWidth
            select
            disabled={isDisabled}
          >
            {budgetOptions.map(option => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField
            label={'Срок покупки'}
            name={'approximateBuy'}
            value={commentsRSE?.approximateBuy}
            onChange={onChange}
            fullWidth
            select
            disabled={isDisabled}
          >
            {approximateBuyOptions.map(option => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField
            label={'Сумма первоначального взноса,₸'}
            name={'prepayment'}
            value={commentsRSE?.prepayment?.toString()?.thousandSeparator()}
            onChange={onChange}
            fullWidth
            disabled={isDisabled}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField
            label={'Наличие автомобиля'}
            name={'carOwnership'}
            value={commentsRSE?.carOwnership}
            onChange={onChange}
            fullWidth
            select
            disabled={isDisabled}
          >
            {carOwnershipOptions.map(option => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>{' '}
        </Grid>

        {/*<Grid item xs={12} md={4}>*/}
        {/*  Процентная ставка ПВ*/}
        {/*  <PercentSlider disabled={isDisabled} />*/}
        {/*</Grid>*/}

        <Grid item xs={12}>
          <TextField
            multiline
            minRows={3}
            name={'additionalInfo'}
            value={commentsRSE?.additionalInfo}
            onChange={onChange}
            fullWidth
            label="Доп. информация (при необходимости)"
            className={classes.textArea}
            disabled={isDisabled}
          />
        </Grid>
      </Grid>
      <RadioGroup
        aria-label="paymentType"
        name="paymentType"
        value={commentsRSE?.paymentType}
        onChange={onChange}
        row
        className={classes.radioBox}
        disabled={isDisabled}
      >
        <FormControlLabel
          value="cash"
          control={<Radio color={'primary'} disabled={isDisabled} />}
          label="Наличными"
        />
        <FormControlLabel
          value="credit"
          control={<Radio color={'primary'} disabled={isDisabled} />}
          label="В кредит"
        />
      </RadioGroup>
      <FormGroup row disabled={isDisabled}>
        <FormControlLabel
          value={commentsRSE?.isTradeIn}
          onChange={onCheck}
          control={<Checkbox name="isTradeIn" color="primary" />}
          label="Trade-in"
          disabled={isDisabled}
        />
      </FormGroup>
    </>
  )
}
